import type { FC, ReactNode } from "react";
import { Box, ClickAwayListener, DialogActions, Portal } from "@mui/material";
import { StyledBox, StyledDialogContent } from "./ModalConstructor.styles";
import {
    isDeviceOutputDesktop,
    isMobileAppDeviceOutput,
} from "../../../../Domain/DeviceOutputState";
import { useBodyScrollModalControlState } from "../Hooks/useBodyScrollModalControl";

interface ModalConstructorProps {
    isBorderRadiusVisible?: boolean;
    isPaddingVisible?: boolean;
    modalActions?: ReactNode;
    modalContent?: ReactNode;
    modalInnerContainerStyles?: object;
    onClose?: () => void;
    open?: boolean;
}

export const ModalConstructor: FC<ModalConstructorProps> = (props) => {
    const {
        onClose,
        open,
        modalContent,
        modalActions,
        isPaddingVisible = false,
        modalInnerContainerStyles,
    } = props;
    const isMobileApp = isMobileAppDeviceOutput();
    const isDesktop = isDeviceOutputDesktop();
    useBodyScrollModalControlState((!isDesktop && open) as boolean);

    return (
        <Portal disablePortal={true}>
            <Box
                sx={{
                    opacity: open ? 1 : 0,
                    position: "fixed",
                    zIndex: 25,
                }}
            >
                <ClickAwayListener
                    onClickAway={(e) => {
                        e.stopPropagation();
                        open && onClose?.();
                    }}
                >
                    <Box
                        sx={{
                            position: "fixed",
                            width: "100%",
                            zIndex: 26,
                            maxWidth: "640px",
                            bottom: "12px",
                            "@media(max-width:639px)": {
                                bottom: "0",
                                maxWidth: "640px",
                            },
                        }}
                    >
                        {!isDesktop && open && (
                            <Box
                                sx={{
                                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                                    height: "150vh",
                                    margin: "-100px 0",
                                }}
                                onClick={() => open && onClose?.()}
                            />
                        )}
                        <StyledBox
                            isMobileApp={isMobileApp}
                            modalInnerContainerStyles={
                                modalInnerContainerStyles
                            }
                        >
                            <Box sx={{ position: "relative" }}>
                                <StyledDialogContent
                                    isPaddingVisible={isPaddingVisible}
                                    dividers={false}
                                >
                                    {modalContent}
                                </StyledDialogContent>
                                {modalActions && (
                                    <>
                                        <DialogActions>
                                            {modalActions}
                                        </DialogActions>
                                    </>
                                )}
                            </Box>
                        </StyledBox>
                    </Box>
                </ClickAwayListener>
            </Box>
        </Portal>
    );
};
